export interface IconStepperProgressProps extends React.SVGProps<SVGSVGElement> {
    hasError?: boolean;
}

export const IconStepperProgress = ({ hasError, ...rest }: IconStepperProgressProps) => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <circle cx="6" cy="6" r="4.5" fill="#F7F8FA" stroke={hasError ? "#FA5252" : "#30A9D4"} strokeWidth="3" />
        </svg>
    );
};
